export default __webpack_public_path__ + "static/media/bg_low.af2962b2.svg";